import * as React from 'react';

import { ScrollToMessageLoader } from '../../components/ScrollToMessageLoader/ScrollToMessageLoader';
import { useIsReplyScrollLoading } from '../../utils/replyScrollContext';

export const ScrollToMessageLoaderContainer: React.FC = () => {
  const { isReplyScrollProcessing, cancelHistoryLoading } = useIsReplyScrollLoading();

  if (!isReplyScrollProcessing) {
    return null;
  }

  return <ScrollToMessageLoader onCancel={cancelHistoryLoading} />;
};
